import apiConfig from "../../utils/config.json";
import httpService from "../httpService";

const apiEndPoint = `${apiConfig.apiUrl}api/salary/bonusGenerate`;
const apiEndPointForGeneratedData = `${apiConfig.apiUrl}dpStaff/get/salarySummary`;
const apiEndPointForOpenHoursBonusData = `${apiConfig.apiUrl}dpStaff/get/openTimeBonus`;
const apiEndPointForPerformanceBonusData = `${apiConfig.apiUrl}dpStaff/get/performanceBonus`;
const apiEndPointForPPCBonusData = `${apiConfig.apiUrl}dpStaff/get/pcsBonus`;
const apiEndPointFinalSalaryData = `${apiConfig.apiUrl}dpStaff/get/finalSalary`;

export function getGeneratedData(value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(apiEndPointForGeneratedData, obj);
}

export function getOpenHoursData(id, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPointForOpenHoursBonusData}/${id}`, obj);
}
export function getPerformanceData(id, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPointForPerformanceBonusData}/${id}`, obj);
}
export function getPCData(id, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPointForPPCBonusData}/${id}`, obj);
}

export function getFinalSalaryData(id, value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return httpService.post(`${apiEndPointFinalSalaryData}/${id}`, obj);
}

export function getSelectedDateRangeData(startDate, endDate) {
  const obj = {
    fromDate: startDate,
    toDate: endDate,
  };
  return httpService.post(apiEndPoint, obj);
}

export default {
  getSelectedDateRangeData,
  getGeneratedData,
  getOpenHoursData,
  getPCData,
  getFinalSalaryData
};
